import React from 'react';

import { Layout, Result } from 'antd';

export function SignUpLimitReachedInvite() {
    return (
        <Layout
            data-component="SignUpLimitReachedInvite"
            style={{ 
                minHeight: '100vh', 
                alignItems: 'center', 
                justifyContent: 'center'
            }}
        >
            <Result
                status="403"
                title="Convite limitado"
                subTitle="O limite de inscrições deste convite foi atingido."
            />
        </Layout>
    );
}
